import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'aos/dist/aos.css';
import './index.css';
import App from './App';


import { HashRouter } from "react-router-dom";




const root = ReactDOM.createRoot(document.getElementById("root"));


root.render(
  <HashRouter>
    <App />
  </HashRouter>
);